import React from 'react'

import styled from 'styled-components'

import { P } from '../../../../../style/Typography.style'

const Question = ({ jobQuestion, onQuestionClicked, note1, note2 }) => {
  const checkIfNoteIsEmpty = (note1, note2) => {
    if (
      (note1 === '<p><br></p>' || note1 === '') &&
      (note2 === '<p><br></p>' || note2 === '')
    )
      return (
        <span
          onClick={() => onQuestionClicked(jobQuestion.question_id)}
          style={{ cursor: 'pointer' }}
        >
          ✏️
        </span>
      )
    return (
      <span
        onClick={() => onQuestionClicked(jobQuestion.question_id)}
        style={{ cursor: 'pointer' }}
      >
        🗒️
      </span>
    )
  }

  return (
    <StyledQuestion>
      {checkIfNoteIsEmpty(note1, note2)}
      <P
        withHover
        cursor="pointer"
        textAlign="justify"
        data-questionid={jobQuestion.question_id}
        onClick={() => onQuestionClicked(jobQuestion.question_id)}
      >
        {jobQuestion.question}
      </P>
    </StyledQuestion>
  )
}

const StyledQuestion = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;

  span {
    color: red;
  }
`

export default Question
